import { TextField, type TextFieldProps } from "./TextField";

export interface LastNameFieldProps extends Omit<TextFieldProps, "name"> {
  /** Por defecto `"lastName"`, que es como se llama en los contratos. */
  name?: string;
}

/**
 * Los apellidos, separados del nombre de pila.
 *
 * `autoComplete="family-name"` es la otra mitad de `given-name`: el par
 * completo es lo que permite al navegador repartir un contacto guardado
 * entre los dos campos en vez de duplicar el nombre entero.
 *
 * El label va en plural —"Apellidos", no "Apellido"— porque en México se
 * usan dos y el campo los guarda juntos.
 */
export function LastNameField({ name = "lastName", ...rest }: LastNameFieldProps) {
  return (
    <TextField
      label="Apellidos"
      placeholder="González Ruiz"
      autoComplete="family-name"
      autoCapitalize="words"
      {...rest}
      name={name}
    />
  );
}
